import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { ResetStateDefaults } from '../../../base-action-class.model';
import { RMessageCategory } from './r-message-category.action';

interface RMessageCategoryXsStateModel {
  viewGlobalMessageCategory: string;
  createGlobalMessageCategory: string;
  editGlobalMessageCategory: string;
  deleteGlobalMessageCategory: string;
}

const getDefaults = (): RMessageCategoryXsStateModel => ({
  viewGlobalMessageCategory: null,
  createGlobalMessageCategory: null,
  editGlobalMessageCategory: null,
  deleteGlobalMessageCategory: null
});

@State<RMessageCategoryXsStateModel>({
  name: 'rMessageCategory',
  defaults: getDefaults()
})
@Injectable()
export class RMessageCategoryXsState {

  //region SELECTOR
  @Selector()
  static canViewGlobalMessageCategory(state: RMessageCategoryXsStateModel): boolean {
    return state.viewGlobalMessageCategory != null;
  }

  @Selector()
  static canCreateGlobalMessageCategory(state: RMessageCategoryXsStateModel): boolean {
    return state.createGlobalMessageCategory != null;
  }

  @Selector()
  static canEditGlobalMessageCategory(state: RMessageCategoryXsStateModel): boolean {
    return state.editGlobalMessageCategory != null;
  }

  @Selector()
  static canDeleteGlobalMessageCategory(state: RMessageCategoryXsStateModel): boolean {
    return state.deleteGlobalMessageCategory != null;
  }
  //endregion

  //region ACTIONS
  @Action(RMessageCategory.SetMessageCategoryPrivileges)
  public setOrganizationPrivileges(ctx: StateContext<RMessageCategoryXsStateModel>, action: RMessageCategory.SetMessageCategoryPrivileges) {
    const state = ctx.getState();
    const designationPrivileges = [...action.activeUserRightInfoDtoModel.designationPrivileges];

    //find user privilege data model
    const viewGlobalMessageCategory = designationPrivileges.find(id => id === UserPrivilegeEnum.VIEW_GLOBAL_MESSAGE_CATEGORY);
    const createGlobalMessageCategory = designationPrivileges.find(id => id === UserPrivilegeEnum.CREATE_GLOBAL_MESSAGE_CATEGORY);
    const editGlobalMessageCategory = designationPrivileges.find(id => id === UserPrivilegeEnum.EDIT_GLOBAL_MESSAGE_CATEGORY);
    const deleteGlobalMessageCategory = designationPrivileges.find(id => id === UserPrivilegeEnum.DELETE_GLOBAL_MESSAGE_CATEGORY);

    //set the state
    ctx.setState({
      ...state,
      viewGlobalMessageCategory: viewGlobalMessageCategory,
      createGlobalMessageCategory: createGlobalMessageCategory,
      editGlobalMessageCategory: editGlobalMessageCategory,
      deleteGlobalMessageCategory: deleteGlobalMessageCategory,
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RMessageCategoryXsStateModel>): void {
    ctx.setState({...getDefaults()});
  }
  //endregion
}
